import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../Styles/Navbar.css";

function Navbar() {
  const { t, i18n } = useTranslation();
  const [nav, setNav] = useState(false);

  const openNav = () => {
    setNav(!nav);
  };

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === "en" ? "he" : "en");
  };

  const isRTL = i18n.language === "he";

  return (
    <div className={`navbar-section ${isRTL ? "rtl" : ""}`}>
      {/* Title */}
      <h1 className="navbar-title">
        <Link to="/">
          {isRTL ? (
            <>
              ד"ר שחאדה <span className="navbar-sign">חביב</span>
            </>
          ) : (
            <>
              Dr.Shada <span className="navbar-sign">Habib</span>
            </>
          )}
        </Link>
      </h1>

      {/* Desktop Menu */}
      <ul className="navbar-items">
        <li><Link to="/" className="navbar-links">{t("home")}</Link></li>
        <li><a href="#services" className="navbar-links">{t("services")}</a></li>
        <li><a href="#about" className="navbar-links">{t("about")}</a></li>
        <li><a href="#reviews" className="navbar-links">{t("reviews")}</a></li>
        <li>
          <button onClick={toggleLanguage} className="language-toggle">
            <FontAwesomeIcon icon={faGlobe} className="globe-icon" /> {t("toggle")}
          </button>
        </li>
      </ul>

      {/* Mobile Menu */}
      <div className={`mobile-navbar ${nav ? "open-nav" : ""} ${isRTL ? "rtl" : ""}`}>
        <div onClick={openNav} className="mobile-navbar-close">
          <FontAwesomeIcon icon={faXmark} className="hamb-icon" />
        </div>

        <ul className={`mobile-navbar-links ${isRTL ? "rtl" : ""}`}>
          <li><Link onClick={openNav} to="/">{t("home")}</Link></li>
          <li><a onClick={openNav} href="#services">{t("services")}</a></li>
          <li><a onClick={openNav} href="#about">{t("about")}</a></li>
          <li><a onClick={openNav} href="#reviews">{t("reviews")}</a></li>
          <li>
            <button
              onClick={() => {
                openNav();
                toggleLanguage();
              }}
              className="language-toggle"
            >
              <FontAwesomeIcon icon={faGlobe} className="globe-icon" /> {t("toggle")}
            </button>
          </li>
        </ul>
      </div>

      {/* Hamburger Button */}
      <div className="mobile-nav">
        <FontAwesomeIcon
          icon={faBars}
          onClick={openNav}
          className="hamb-icon"
        />
      </div>
    </div>
  );
}

export default Navbar;
